import { createBrowserHistory } from 'history';
// Create a single history to be shared between the whole project.
export default createBrowserHistory();
